import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className, count }) {
    return (
        <label className={`ns-checkbox ${className || ''}`}>
            <input type="checkbox" checked={selected} onChange={onChange} />
            <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>
            </svg>
            <svg className="ns-checkmark" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="24px" height="24px">
                <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" fill="currentColor"/>
            </svg>
            <span className="ns-checkbox-label-text">
                {value} {count && `(${count})`}
            </span>
        </label>
    )
}